<!--


gotta assign each project to an id and create a ProjectHelper to get the uris and stuffs


-->


<template>
    <div style="padding-top:0px;">
        <ion-modal v-if="ModalOpen" ref="modal" :is-open="ModalOpen" :can-dismiss="canDismiss" >
            <ion-header>
                <ion-toolbar>
                    <ion-buttons slot="start">
                        <ion-button @click="closeModal">Return to Projects</ion-button>
                    </ion-buttons>
                    <ion-title>{{ routeTitle }}</ion-title>

                </ion-toolbar>
            </ion-header>
            <ion-content class="ion-padding">
                <ion-item lines="none">
                    <div style="width:100%">
                        <ion-grid>
                            <ion-row style="gap: 15px;">
                                <ion-col v-for="(asset, index) in assets" :key="index"
                                    style="    justify-items: center;">

                                    <ion-img class="project-img"
                                        :src="(asset.asset as string).startsWith('$') ? (asset.asset as string).replace('$', '') : 'https://aes-site-assets.pages.dev/projects/' + (asset.asset as string)"></ion-img>
                                    <div v-if="asset.description" style="margin-top: 10px;">
                                        {{ asset.description }}
                                    </div>

                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </div>
                </ion-item>


            </ion-content>
        </ion-modal>
    </div>
</template>
<script setup lang="ts">
import settings from "@/settings/email.json";
import { computed, ref, onBeforeMount, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
    IonPage,
    IonIcon,
    IonHeader,
    IonFooter,
    IonToolbar,
    IonButtons,
    IonSelectOption,
    IonMenuButton,
    IonTextarea,
    IonModal,
    IonButton,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonGrid,
    IonTitle,
    IonRow,
    IonCol,
    IonInput,
    IonToast,
    IonSelect,
    IonRadioGroup,
    IonRadio, toastController
} from "@ionic/vue";
const modal = ref<InstanceType<typeof IonModal> | null>(null);


onBeforeMount(() => {
    if (useRoute().query.assets == undefined) {

        closeModal();
    }
});

var routeTitle = computed(() => {
    const route = useRoute();
    return route.query.routeTitle || "Project Collage";
});
var assets = computed(() => {
    const route = useRoute();
    try {
        return JSON.parse(route.query.assets as string) || [];
    } catch (e) {
        return [];
    }
});
var ModalOpen = ref(false)
var RouteName = ref("")
var canDismiss = ref(false); // Allow modal to be dismissed
const route = useRoute();
const router = useRouter();

// Open modal when route matches
watch(
    () => route.path, // Use `route.path` to ignore query parameters
    (newPath) => {
        if (newPath === "/project") {
            ModalOpen.value = true; // Open the modal for the `/project` route
        } else {
            ModalOpen.value = false; // Ensure the modal is closed for other routes
        }
    },
    { immediate: true }
);


var allowedSites = [
    "https://aes-site-revamp.pages.dev",
    "https://www.aes-site-revamp.pages.dev",
    "https://aes-site-revamp.pages.dev",
    "http://localhost:5173"
];
console.log(router.options.history.state.back)

function back() {
    if (router.options.history.state.back) {
        for (const site of allowedSites) {
            if (router.options.history.state.back.toString().includes(site)) {
                // If the back URL is one of the allowed sites, navigate back
                router.push("/")
                return;
            }
        }

    }
    router.back();

}

function closeModal() {
    ModalOpen.value = false; // Close the modal
    canDismiss.value = false; // Reset the dismiss state

    // Navigate to the projects page after ensuring the modal is fully dismissed
    setTimeout(() => {
        ModalOpen.value = false; // Ensure modal is fully closed
        router.replace("/projects"); // Redirect to the projects page
    }, 300); // Slight delay to ensure the modal is fully dismissed
}


</script>
<style></style>
<script lang="ts">
import * as outlines from 'ionicons/icons';
import router from "@/router";

export default {
    name: 'ProjectCollage',

}
</script>

